// UI copy in English (default), German, Greek. Auto-translated — review & tweak as needed.
export const LANGS = [
  { code: "en", label: "EN" },
  { code: "de", label: "DE" },
  { code: "el", label: "EL" },
];

export const T = {
  en: {
    nav: { about: "About", lounges: "Lounges", families: "Families", activities: "Activities", menu: "Menu", gallery: "Gallery", contact: "Contact" },
    common: { book: "Book Now", reserve: "Reserve a Lounge", viewMenu: "View Full Menu", followIg: "Follow on Instagram" },
    hero: {
      location: "Tigaki, Kos, Greece",
      headline: "Where time flows.",
      sub: "A beach lounge built for slow living — sun, salt, sunsets and cocktails. Open daily till late.",
    },
    about: {
      eyebrow: "Our Story",
      title: "A quieter way to spend a day by the water.",
      p1: "Tribe Beach Lounge is an invitation to slow down. We built this place around the simple things — the warmth of the sand, a long lunch that drifts into the afternoon, and the colour of the sky as the sun slips into the sea.",
      p2: "No rush. No noise. Just the rhythm of the coast and good company.",
      stat1: "Private Cabanas",
      stat2: "Sunsets",
    },
    access: [
      { title: "Open to Everyone", desc: "You don't need to be a TAF guest. Tribe Beach is open to all — locals, visitors and families alike." },
      { title: "Free Sunbeds & Lounges", desc: "No entry fee. Sunbeds and lounges are free — only a minimum consumption applies, depending on the size you choose." },
      { title: "Free Water Sports Gear", desc: "SUP boards, kayaks and water equipment are completely free to use throughout the day." },
    ],
    lounges: {
      eyebrow: "Spaces",
      title: "Find your spot on the sand.",
      cards: [
        { title: "The Cabanas", desc: "Private daybeds beneath timber pergolas, draped for shade and steps from the shoreline — your own quiet corner of Kos." },
        { title: "Seaside Retreat", desc: "An intimate Aegean hideaway where clear turquoise water meets warm sand and slow, golden afternoons." },
        { title: "The Beachfront", desc: "Loungers facing the open sea, for long swims, soft breezes and the first cool light of evening." },
      ],
      badge: "0€ entry · sunbeds free",
      freeTitle: "The lounges are free — you only pay for what you enjoy.",
      freeDesc: "No entry ticket, no sunbed rental, no hidden fees. You're simply asked for a minimum spend on food & drinks — and it all goes towards what you eat and drink. Choose your spot by size below.",
      sunbedFree: "Sunbed free",
      minSpend: "min. spend",
      tiers: [
        { size: "Small Lounge", guests: "Up to 4 guests" },
        { size: "Medium Lounge", guests: "Up to 8 guests" },
        { size: "Large Lounge", guests: "Up to 10 guests" },
      ],
    },
    families: {
      eyebrow: "Made for Families",
      title: "A beach day the whole tribe will love.",
      p: "We're proudly family-friendly. While the kids build castles and play in the dedicated playground, parents can sink into a daybed with a cold drink — everyone in their happy place, all in one spot.",
      perks: ["Dedicated kids' playground", "Shallow, calm swimming water", "Family cabanas & daybeds", "Little ones' menu & fresh fruit"],
    },
    activities: {
      eyebrow: "Things to Do",
      title: "From sunrise paddles to sunset cocktails.",
      items: [
        { title: "Stand-Up Paddle", desc: "Glide over glassy morning water on our SUP boards — free to use for all our guests, all levels welcome." },
        { title: "Sea Kayak", desc: "Paddle out and explore the coastline and hidden coves — kayaks are free to use throughout the day." },
        { title: "Self-Drive Boat Rental", desc: "Captain your own day on the Aegean. No licence required — available for half or full day." },
        { title: "Beach Spa", desc: "Unwind with a massage by the sea — treatments in the shade, set to the sound of the waves." },
        { title: "Sunset Cocktails", desc: "We stay open till late. Signature cocktails, slow music and the best sunsets on the island." },
        { title: "Kids' Playground", desc: "A dedicated playground in the sand keeps little ones happy while you settle into the day." },
      ],
    },
    menu: {
      eyebrow: "Bites & Drinks",
      title: "Snacks & cocktails, made with care.",
      p: "A relaxed selection of snacks and light bites made with fresh ingredients and prepared with care — plus signature cocktails for the golden hour. Served from morning till late.",
      note: "Open to everyone — you don't need to be a TAF guest to enjoy Tribe Beach.",
    },
    instagram: { eyebrow: "Follow Along" },
    soundtrack: {
      eyebrow: "The Tribe Soundtrack",
      title: "Press play, drift away.",
      p: "The music that plays as the sun goes down at Tribe Beach. Hit play and bring a little bit of Tigaki wherever you are — or save it for your next visit.",
    },
    gallery: { eyebrow: "Gallery", title: "Moments from the shore." },
    contact: {
      eyebrow: "Get in Touch",
      title: "Come find us by the sea.",
      p: "Questions, big groups or a special occasion? The quickest way to reach us is a quick message on WhatsApp or a call.",
      hours: "Open daily · 9:00 till late",
    },
    footer: {
      rights: "All rights reserved.",
      motto: "Where time flows.",
      seo: "Tribe Beach Lounge is a family-friendly beach bar and lounge on Tigaki beach in Kos, Greece. Enjoy free sunbeds and cabanas with a simple minimum consumption, free SUP boards and sea kayaks, self-drive boat rental on the Aegean, beach massages, fresh snacks and signature sunset cocktails — open daily from 9:00 until late, all summer long.",
    },
  },

  de: {
    nav: { about: "Über uns", lounges: "Lounges", families: "Familien", activities: "Aktivitäten", menu: "Menü", gallery: "Galerie", contact: "Kontakt" },
    common: { book: "Jetzt buchen", reserve: "Lounge reservieren", viewMenu: "Ganze Karte ansehen", followIg: "Auf Instagram folgen" },
    hero: {
      location: "Tigaki, Kos, Griechenland",
      headline: "Wo die Zeit fließt.",
      sub: "Eine Beach-Lounge für entschleunigtes Leben — Sonne, Meer, Sonnenuntergänge und Cocktails. Täglich bis spät geöffnet.",
    },
    about: {
      eyebrow: "Unsere Geschichte",
      title: "Ein ruhigerer Tag am Wasser.",
      p1: "Die Tribe Beach Lounge lädt zum Entschleunigen ein. Wir haben diesen Ort um die einfachen Dinge herum geschaffen — die Wärme des Sandes, ein langes Mittagessen, das in den Nachmittag übergeht, und die Farbe des Himmels, wenn die Sonne im Meer versinkt.",
      p2: "Keine Hektik. Kein Lärm. Nur der Rhythmus der Küste und gute Gesellschaft.",
      stat1: "Private Cabanas",
      stat2: "Sonnenuntergänge",
    },
    access: [
      { title: "Für alle offen", desc: "Sie müssen kein TAF-Gast sein. Tribe Beach ist für alle da — Einheimische, Besucher und Familien." },
      { title: "Kostenlose Liegen & Lounges", desc: "Kein Eintritt. Liegen und Lounges sind kostenlos — es gilt lediglich ein Mindestverzehr, je nach gewählter Größe." },
      { title: "Kostenlose Wassersportausrüstung", desc: "SUP-Boards, Kajaks und Wasserausrüstung können den ganzen Tag kostenlos genutzt werden." },
    ],
    lounges: {
      eyebrow: "Bereiche",
      title: "Finden Sie Ihren Platz im Sand.",
      cards: [
        { title: "Die Cabanas", desc: "Private Liegen unter Holzpergolen, schattig und nur wenige Schritte vom Wasser entfernt — Ihre ruhige Ecke auf Kos." },
        { title: "Rückzugsort am Meer", desc: "Ein intimes Versteck an der Ägäis, wo klares türkisfarbenes Wasser auf warmen Sand und lange, goldene Nachmittage trifft." },
        { title: "Der Strandbereich", desc: "Liegen mit Blick aufs offene Meer — für lange Schwimmzüge, sanfte Brisen und das erste kühle Abendlicht." },
      ],
      badge: "0€ Eintritt · Liegen kostenlos",
      freeTitle: "Die Lounges sind kostenlos — Sie zahlen nur, was Sie genießen.",
      freeDesc: "Kein Eintrittsticket, keine Liegengebühr, keine versteckten Kosten. Es gilt lediglich ein Mindestverzehr für Speisen & Getränke — und der zählt voll für das, was Sie essen und trinken. Wählen Sie Ihren Platz nach Größe unten.",
      sunbedFree: "Liege kostenlos",
      minSpend: "Mindestverzehr",
      tiers: [
        { size: "Kleine Lounge", guests: "Bis zu 4 Gäste" },
        { size: "Mittlere Lounge", guests: "Bis zu 8 Gäste" },
        { size: "Große Lounge", guests: "Bis zu 10 Gäste" },
      ],
    },
    families: {
      eyebrow: "Für Familien gemacht",
      title: "Ein Strandtag, den die ganze Tribe liebt.",
      p: "Wir sind mit Stolz familienfreundlich. Während die Kinder Sandburgen bauen und auf dem eigenen Spielplatz spielen, können die Eltern mit einem kühlen Drink auf der Liege entspannen — alle glücklich, alle an einem Ort.",
      perks: ["Eigener Kinderspielplatz", "Flaches, ruhiges Badewasser", "Familien-Cabanas & Liegen", "Kindermenü & frisches Obst"],
    },
    activities: {
      eyebrow: "Zu erleben",
      title: "Vom Morgenpaddeln bis zu Cocktails bei Sonnenuntergang.",
      items: [
        { title: "Stand-Up-Paddle", desc: "Gleiten Sie über das glatte Morgenwasser auf unseren SUP-Boards — für alle Gäste kostenlos, alle Levels willkommen." },
        { title: "Seekajak", desc: "Paddeln Sie hinaus und entdecken Sie die Küste und versteckte Buchten — Kajaks sind den ganzen Tag kostenlos." },
        { title: "Bootsverleih (selbst fahren)", desc: "Steuern Sie Ihren eigenen Tag auf der Ägäis. Kein Führerschein nötig — halb- oder ganztags verfügbar." },
        { title: "Beach-Spa", desc: "Entspannen Sie bei einer Massage am Meer — Anwendungen im Schatten, begleitet vom Klang der Wellen." },
        { title: "Cocktails bei Sonnenuntergang", desc: "Wir haben bis spät geöffnet. Signature-Cocktails, ruhige Musik und die schönsten Sonnenuntergänge der Insel." },
        { title: "Kinderspielplatz", desc: "Ein eigener Spielplatz im Sand hält die Kleinen glücklich, während Sie den Tag genießen." },
      ],
    },
    menu: {
      eyebrow: "Snacks & Drinks",
      title: "Snacks & Cocktails, mit Liebe gemacht.",
      p: "Eine entspannte Auswahl an Snacks und kleinen Gerichten aus frischen Zutaten, mit Sorgfalt zubereitet — dazu Signature-Cocktails für die goldene Stunde. Von morgens bis spät serviert.",
      note: "Für alle offen — Sie müssen kein TAF-Gast sein, um Tribe Beach zu genießen.",
    },
    instagram: { eyebrow: "Folgen Sie uns" },
    soundtrack: {
      eyebrow: "Der Tribe-Soundtrack",
      title: "Play drücken, treiben lassen.",
      p: "Die Musik, die am Tribe Beach läuft, wenn die Sonne untergeht. Drücken Sie Play und holen Sie sich ein Stück Tigaki, wo immer Sie sind — oder speichern Sie sie für Ihren nächsten Besuch.",
    },
    gallery: { eyebrow: "Galerie", title: "Momente am Meer." },
    contact: {
      eyebrow: "Kontakt",
      title: "Besuchen Sie uns am Meer.",
      p: "Fragen, große Gruppen oder ein besonderer Anlass? Am schnellsten erreichen Sie uns per WhatsApp oder Anruf.",
      hours: "Täglich geöffnet · 9:00 bis spät",
    },
    footer: {
      rights: "Alle Rechte vorbehalten.",
      motto: "Wo die Zeit fließt.",
      seo: "Die Tribe Beach Lounge ist eine familienfreundliche Beach-Bar und Lounge am Strand von Tigaki auf Kos, Griechenland. Genießen Sie kostenlose Liegen und Cabanas mit einfachem Mindestverzehr, kostenlose SUP-Boards und Seekajaks, Bootsverleih zum Selbstfahren auf der Ägäis, Strandmassagen, frische Snacks und Signature-Cocktails zum Sonnenuntergang — täglich von 9:00 bis spät geöffnet, den ganzen Sommer.",
    },
  },

  el: {
    nav: { about: "Σχετικά", lounges: "Lounges", families: "Οικογένειες", activities: "Δραστηριότητες", menu: "Μενού", gallery: "Gallery", contact: "Επικοινωνία" },
    common: { book: "Κράτηση", reserve: "Κράτηση Lounge", viewMenu: "Δείτε το Μενού", followIg: "Ακολουθήστε στο Instagram" },
    hero: {
      location: "Τιγκάκι, Κως, Ελλάδα",
      headline: "Εκεί που ο χρόνος κυλά.",
      sub: "Μια beach lounge για χαλαρές στιγμές — ήλιος, θάλασσα, ηλιοβασιλέματα και κοκτέιλ. Ανοιχτά κάθε μέρα ως αργά.",
    },
    about: {
      eyebrow: "Η ιστορία μας",
      title: "Ένας πιο ήρεμος τρόπος να περάσετε τη μέρα σας δίπλα στο νερό.",
      p1: "Το Tribe Beach Lounge είναι μια πρόσκληση να επιβραδύνετε. Φτιάξαμε αυτόν τον χώρο γύρω από τα απλά πράγματα — τη ζεστασιά της άμμου, ένα μεσημεριανό που κυλά μέχρι το απόγευμα και το χρώμα του ουρανού καθώς ο ήλιος βυθίζεται στη θάλασσα.",
      p2: "Χωρίς βιασύνη. Χωρίς θόρυβο. Μόνο ο ρυθμός της ακτής και καλή παρέα.",
      stat1: "Ιδιωτικές Cabanas",
      stat2: "Ηλιοβασιλέματα",
    },
    access: [
      { title: "Ανοιχτά για όλους", desc: "Δεν χρειάζεται να είστε πελάτης του TAF. Το Tribe Beach είναι ανοιχτό για όλους — ντόπιους, επισκέπτες και οικογένειες." },
      { title: "Δωρεάν ξαπλώστρες & lounges", desc: "Χωρίς είσοδο. Οι ξαπλώστρες και τα lounges είναι δωρεάν — ισχύει μόνο ελάχιστη κατανάλωση, ανάλογα με το μέγεθος που επιλέγετε." },
      { title: "Δωρεάν εξοπλισμός θαλάσσιων σπορ", desc: "SUP, καγιάκ και εξοπλισμός διατίθενται εντελώς δωρεάν καθ' όλη τη διάρκεια της ημέρας." },
    ],
    lounges: {
      eyebrow: "Χώροι",
      title: "Βρείτε τη γωνιά σας στην άμμο.",
      cards: [
        { title: "Οι Cabanas", desc: "Ιδιωτικά κρεβάτια κάτω από ξύλινες πέργκολες, με σκιά και λίγα βήματα από την ακτή — η δική σας ήσυχη γωνιά στην Κω." },
        { title: "Καταφύγιο δίπλα στη θάλασσα", desc: "Ένα ήσυχο καταφύγιο στο Αιγαίο, όπου τα καθαρά τυρκουάζ νερά συναντούν τη ζεστή άμμο και τα χρυσά απογεύματα." },
        { title: "Το μέτωπο της παραλίας", desc: "Ξαπλώστρες με θέα στο ανοιχτό πέλαγος — για μεγάλες βουτιές, απαλό αεράκι και το πρώτο δροσερό φως του δειλινού." },
      ],
      badge: "0€ είσοδος · δωρεάν ξαπλώστρες",
      freeTitle: "Τα lounges είναι δωρεάν — πληρώνετε μόνο ό,τι απολαμβάνετε.",
      freeDesc: "Χωρίς εισιτήριο, χωρίς ενοίκιο ξαπλώστρας, χωρίς κρυφές χρεώσεις. Ισχύει απλώς μια ελάχιστη κατανάλωση σε φαγητό & ποτό — και πάει εξ ολοκλήρου σε αυτά που τρώτε και πίνετε. Διαλέξτε τη θέση σας ανά μέγεθος παρακάτω.",
      sunbedFree: "Δωρεάν ξαπλώστρα",
      minSpend: "ελάχιστη κατανάλωση",
      tiers: [
        { size: "Μικρό Lounge", guests: "Έως 4 άτομα" },
        { size: "Μεσαίο Lounge", guests: "Έως 8 άτομα" },
        { size: "Μεγάλο Lounge", guests: "Έως 10 άτομα" },
      ],
    },
    families: {
      eyebrow: "Φτιαγμένο για οικογένειες",
      title: "Μια μέρα στην παραλία για όλη την παρέα.",
      p: "Είμαστε περήφανα φιλικοί προς τις οικογένειες. Όσο τα παιδιά χτίζουν κάστρα και παίζουν στην παιδική χαρά, οι γονείς χαλαρώνουν σε μια ξαπλώστρα με ένα δροσερό ποτό — όλοι στη χαρά τους, όλοι σε έναν χώρο.",
      perks: ["Ειδική παιδική χαρά", "Ρηχά, ήρεμα νερά", "Οικογενειακές cabanas & ξαπλώστρες", "Παιδικό μενού & φρέσκα φρούτα"],
    },
    activities: {
      eyebrow: "Τι να κάνετε",
      title: "Από το πρωινό paddle ως τα κοκτέιλ του δειλινού.",
      items: [
        { title: "Stand-Up Paddle", desc: "Γλιστρήστε πάνω στα ήρεμα πρωινά νερά με τα SUP μας — δωρεάν για όλους τους επισκέπτες, όλα τα επίπεδα ευπρόσδεκτα." },
        { title: "Θαλάσσιο καγιάκ", desc: "Βγείτε στα ανοιχτά και εξερευνήστε την ακτή και κρυφούς κόλπους — τα καγιάκ είναι δωρεάν όλη μέρα." },
        { title: "Ενοικίαση σκάφους (χωρίς δίπλωμα)", desc: "Οδηγήστε μόνοι σας μια μέρα στο Αιγαίο. Δεν απαιτείται δίπλωμα — διαθέσιμο για μισή ή ολόκληρη ημέρα." },
        { title: "Beach Spa", desc: "Χαλαρώστε με ένα μασάζ δίπλα στη θάλασσα — θεραπείες στη σκιά, με ήχο τα κύματα." },
        { title: "Κοκτέιλ στο ηλιοβασίλεμα", desc: "Μένουμε ανοιχτά ως αργά. Signature κοκτέιλ, χαλαρή μουσική και τα καλύτερα ηλιοβασιλέματα του νησιού." },
        { title: "Παιδική χαρά", desc: "Μια ειδική παιδική χαρά στην άμμο κρατά τα μικρά χαρούμενα όσο εσείς χαλαρώνετε." },
      ],
    },
    menu: {
      eyebrow: "Snacks & Ποτά",
      title: "Snacks & κοκτέιλ, φτιαγμένα με φροντίδα.",
      p: "Μια χαλαρή επιλογή από snacks και ελαφριά πιάτα με φρέσκα υλικά, φτιαγμένα με φροντίδα — μαζί με signature κοκτέιλ για τη χρυσή ώρα. Σερβίρονται από το πρωί ως αργά.",
      note: "Ανοιχτά για όλους — δεν χρειάζεται να είστε πελάτης του TAF για να απολαύσετε το Tribe Beach.",
    },
    instagram: { eyebrow: "Ακολουθήστε μας" },
    soundtrack: {
      eyebrow: "Το Soundtrack του Tribe",
      title: "Πατήστε play και αφεθείτε.",
      p: "Η μουσική που παίζει στο Tribe Beach όταν δύει ο ήλιος. Πατήστε play και πάρτε λίγο Τιγκάκι μαζί σας όπου κι αν είστε — ή αποθηκεύστε τη για την επόμενη επίσκεψή σας.",
    },
    gallery: { eyebrow: "Gallery", title: "Στιγμές στην ακτή." },
    contact: {
      eyebrow: "Επικοινωνία",
      title: "Ελάτε να μας βρείτε δίπλα στη θάλασσα.",
      p: "Ερωτήσεις, μεγάλες παρέες ή μια ειδική περίσταση; Ο πιο γρήγορος τρόπος να μας βρείτε είναι ένα μήνυμα στο WhatsApp ή ένα τηλεφώνημα.",
      hours: "Ανοιχτά κάθε μέρα · 9:00 ως αργά",
    },
    footer: {
      rights: "Με επιφύλαξη παντός δικαιώματος.",
      motto: "Εκεί που ο χρόνος κυλά.",
      seo: "Το Tribe Beach Lounge είναι ένα φιλικό προς τις οικογένειες beach bar και lounge στην παραλία Τιγκάκι της Κω. Απολαύστε δωρεάν ξαπλώστρες και cabanas με απλή ελάχιστη κατανάλωση, δωρεάν SUP και θαλάσσια καγιάκ, ενοικίαση σκάφους χωρίς δίπλωμα στο Αιγαίο, μασάζ στην παραλία, φρέσκα snacks και signature κοκτέιλ στο ηλιοβασίλεμα — ανοιχτά κάθε μέρα από τις 9:00 ως αργά, όλο το καλοκαίρι.",
    },
  },
};
